import { FC } from 'react';
import { REGEX } from '@belong/constants';
import { LIB_INPUTS_DEFAULT_IDS } from '../../../helpers/variables';
import { GenericInput, IExtendedGenericInputDefaultContent } from '../GenericInput';
import CONTENT from './content.json';

export interface IEmailInputProps extends IExtendedGenericInputDefaultContent<
  'required' | 'invalid' | 'emailMaxLength'
> {}

/**
 * A simple form library agnostic email input. It validates emails, and if deemed appropriate can be shown as in error if there's a submit API error
 */
export const EmailInput: FC<IEmailInputProps> = ({ errorMessages, label = CONTENT.label, ...props }) => {
  return (
    <GenericInput
      autoComplete="email"
      errorValidation={[
        { errorKey: 'required', message: errorMessages?.required ?? CONTENT.errorMessage.required },
        {
          errorKey: 'validFormat',
          message: errorMessages?.invalid ?? CONTENT.errorMessage.invalid,
          pattern: REGEX.EMAIL
        },
        {
          errorKey: 'emailMaxLength',
          message: errorMessages?.emailMaxLength ?? CONTENT.errorMessage.emailMaxLength
        }
      ]}
      label={label}
      type="email"
      inputMode="email"
      name={LIB_INPUTS_DEFAULT_IDS.EMAIL}
      {...props}
    />
  );
};

EmailInput.displayName = 'EmailInput';
